export default __webpack_public_path__ + "16f452e.png";